import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { Conversation, ThreadMessage } from 'app/clmtlk/shared/model/conversationContacts';

@Component({
	selector: 'clmtlk-message-list',
	templateUrl: './message-list.component.html',
	styleUrls: ['./message-list.component.scss']
})
export class MessageListComponent implements OnInit {

	@Input() conversation: Conversation;
	threadMessages: ThreadMessage[];

	constructor() { }

	ngOnInit() {
		this.threadMessages = this.conversation
			.conversationThreads.conversationThread[0]
			.threads.thread[0]
			.threadMessages.threadMessage;
	}

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/shared/component/message-list/message-list.component.ts